<template>
    <v-container class="w-100 mb-10" >
        <v-row align="center" class="text-start text-small" v-if="pages">
            <v-col cols="12">
                <v-container>
                    <v-row>
                        <v-col v-for="item in pages" cols="6" md="4" :key="item.id" class="py-1">
                            <v-btn
                                :title="simplifyTitle(item.title)"
                                :to="item.route" 
                                
                                variant="plain"
                                class="text-start w-100 text-white btn-primelinks h-auto justify-content-start"
                                >
                                {{simplifyTitle(item.title)}}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
            <v-col cols="12">
                <v-progress-linear
                    v-if="loading"
                    class="mx-auto"
                    indeterminate
                ></v-progress-linear>
            </v-col>
            <v-col v-if="meta" cols="12">
                <v-container v-if="meta.last_page > 1">
                    <v-pagination
                        size="x-small"
                        total-visible="6"
                        v-model="meta.current_page"
                        :length="meta.last_page"
                        @update:model-value="getList"
                        rounded="0"
                    ></v-pagination>
                    <p class="text-center">
                        {{ meta.from }} - {{ meta.to }} di {{ meta.total }}
                    </p>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapGetters} from "vuex";
export default {
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            pages: 'pages/list',
            meta: 'pages/meta',
            page: 'pages/single',
            adminPage: 'AdminPages/single',
        }),
    },
    props:{
        data:{
            required: false,
            type: Object,
        }
    },
    data: () => ({
        current_page: null,
        items_per_page: 48,
    }),
    mounted(){
        this.current_page = (this.page) ? this.page : this.adminPage;
        if(this.data.items_per_page){
            this.items_per_page = this.data.items_per_page;
        }
        if(this.current_page){
            this.getList();
        }
    },
    methods:{
        simplifyTitle(text){
            text = text.replace('| Primerentcar','');
            text = text.replace('| Primerent','');
            text = text.replace('Exclusive car Hire','');
            text = text.replace(':','');
            text = text.replace('richiedi un preventivo','');
            return text;
        },
        async getList(){
            let filters = {
                items_per_page: this.items_per_page,
                wheres : [
                    {
                        'type': 'and',
                        'column': 'parent_id',
                        'is': '=',
                        'value': this.current_page.id
                    }
               ]
            }
            this.$store.dispatch('pages/setMeta',this.meta)
            this.$store.dispatch('pages/setFilters',filters)
            await this.$store.dispatch('pages/getListLight')
        }
    }
}
</script>